import { caption2, micro } from '@westwing/ui-kit/typography';
import styled from 'styled-components';
import Cart from '@westwing/ui-kit/Icons/Cart';
import Basket from '@westwing/ui-kit/Icons/Basket';
import SpinnerIcon from '@westwing/ui-kit/Spinner';
import { animationRotate } from '@westwing/ui-kit/Animation';

const BADGE_SIZE = '14px';
const BADGE_WRAPPER_HEIGHT = '20px';

export const RotatingSpinner = styled(SpinnerIcon)`
    width: 10px;
    height: 10px;
    margin: 2px;
    animation: ${animationRotate} 0.6s linear infinite;
`;

export const Badgebubble = styled.span`
    ${micro}
    position: absolute;
    color: ${({ theme }) => theme.colors.white};
    border-radius: 50%;
    width: ${BADGE_SIZE};
    height: ${BADGE_SIZE};
    line-height: ${BADGE_SIZE};
    text-align: center;
    left: 11px;
    top: -7px;
    background-color: ${({ theme }) => theme.colors.charcoal100};

    &:empty {
        display: none;
    }
`;

export const Timer = styled.time`
    ${micro}
    color: ${({ theme }) => theme.colors.charcoal50};
    display: block;
    position: absolute;
    width: 100%;
    top: ${BADGE_WRAPPER_HEIGHT};

    &:empty {
        display: none;
    }
    bottom: 3px;
`;

export const StyledCartExpiryCounter = styled.div<{
    $isCartExpired: boolean;
    $isCartOverlayActive: boolean;
    $isClubHeaderInBellaCart: boolean;
}>`
    ${caption2}
    position: absolute;
    bottom: -2px;
    border-radius: 100px;
    text-align: center;
    line-height: 15px;
    padding: ${({ $isClubHeaderInBellaCart }) => ($isClubHeaderInBellaCart ? '0px 10px' : '0px 9px')};
    letter-spacing: ${({ $isClubHeaderInBellaCart }) => ($isClubHeaderInBellaCart ? '.9px' : '.2px')};
    left: -1px;
    font-family: ${({ theme }) => theme.fonts.fontBrandonRegular};
    color: ${({ theme, $isCartExpired, $isCartOverlayActive }) => {
        if ($isCartExpired && $isCartOverlayActive) {
            return theme.colors.charcoal100;
        }
        return $isCartExpired ? theme.colors.red100 : theme.colors.charcoal100;
    }};

    background-color: ${({ theme, $isCartExpired, $isCartOverlayActive }) => {
        if ($isCartOverlayActive) {
            return $isCartExpired ? theme.colors.red50 : theme.colors.yellow50;
        }
        return 'transparent';
    }};
`;

export const BadgeWrapper = styled.div`
    position: relative;
    display: inline-block;
    height: ${BADGE_WRAPPER_HEIGHT};
    width: 50%;
    text-align: center;
    line-height: normal;
`;

export const StyledCart = styled(Cart)`
    vertical-align: baseline;
`;

export const StyledBasket = styled(Basket)`
    vertical-align: baseline;
`;

export const Wrapper = styled.div`
    position: relative;
`;

export const CartIconContainer = styled.div<{ active: string }>`
    [data-type] {
        display: none;
    }
    [data-type='${({ active }) => active}'] {
        display: block !important;
    }
`;
